const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		preventSortOfField: {
			tags: true,
			active: true,
			specialOffer: true
		},
		buttonContext: 'product',
		renderEmptyBeforReady: false,
		showHead: false,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: false,
		showDelimiterBorders: true,
		inline: true,
		maxNrOfExportElements: 500000,
		privilegeBase: 'mblx_products',
		rowActionsProperties: {
			colWidth: '220px'
		},
		rowActions: {},
		customColActionsFile: 'templates/mblx/products/table/customColActions',
		useSelectionObjectFormat: true,
		useSelectionObjectKeyAttribute: 'routeID',
		addRowClassViaAttribute: {
			fieldCode:  'articleUrl',
			class:  'hasArticleUrl',
		},
	},

	model: {
		resourceFilters: {
			order: [{
				fieldCode: 'productID',
				direction: 'asc'
			}]
		}
	},

	methods: {

		dataDealer: function(){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_mblx_products_controller', function(controller){
					self.model.controller = controller
				});
			}

			if(self.model.controller && !self.config.usage){
				self.config.usage = self.model.controller.config.usage || '';
			}

			const productAttributes = this.getResourceRegisterContent('productAttributes') || {};
			if(productAttributes.productID){
				this.model.highlightRowIDs = {
					[productAttributes.productID]: productAttributes.productID
				};
			}

			if(self.config.usage === 'selection' && !self.model.isInPicker){
				self.updateListOfIDs()
			}
		},

		updateListOfIDs: function(){
			if(!this.model.selectedRowIDInitialized){
				this.model.selectedRowIDInitialized = true;
				this.model.selectedRowIDs = utils.simpleCopy(this.getResourceRegisterContent('selectedRowIDs') || []);
				this.model.blackListedProductIDs = utils.simpleCopy(this.getResourceRegisterContent('blackListedProductIDs') || []);
			}
		},

		sanitizeEntity: function(refEntity){
			var self = this;
			if(self.config.usage === 'selection' && self.config.isSelectionSource){
				refEntity.selected = utils.indexOf(self.model.selectedRowIDs, refEntity.attributes[refEntity.primaryKey || 'id']) > -1;
			}
		},

		onResourceSanitized: function(){
			if(this.config.isSelectionTarget){
				// correct order of selected entities
				var entityList = this.model.entityList;
				var orderedEntityList = {};
				var orderedEntityListByIndex = [];
				var entityKey, rowIndex, rowID;
				for(rowIndex in this.model.selectedRowIDs || []){
					rowID = this.model.selectedRowIDs[rowIndex];
					entityKey = `entityID_${rowID}`;
					if(entityList[entityKey]){
						entityList[entityKey].index = rowIndex;
						orderedEntityList[entityKey] = entityList[entityKey];
						orderedEntityListByIndex[rowIndex] = entityList[entityKey];
					}
				}

				this.model.entityList = orderedEntityList;
				this.model.entityListByIndex = orderedEntityListByIndex;
			}
		},

		sanitizeResourceFilters: function(storage, resourceFilters, actionKey){

			if(actionKey === 'refreshResources'){
				// console.log('sanitizeResourceFilters()', actionKey, utils.simpleCopy(resourceFilters))

				var self = this;
				if(self.model.isInPicker === undefined){
					self.model.isInPicker = false;
					self.closest('templates_mblx_products_picker_button', function(pickerButton){
						self.model.isInPicker = true;
						self.model.selectedRowIDs = pickerButton.model.dataJSON || [];
					});
				}

				resourceFilters = resourceFilters || {};
				resourceFilters.baseFilters = resourceFilters.baseFilters || {};

				// initialize selectedRows and other id lists if necessary.
				// this may be the case if the components resources are dependent on these ids.
				// e.g., subProductPicker-selectionTarget-table which has to load the products previously picked according to the given productID-Selection.
				// the dataDealer would usually handle such cases but resourceFilters may be needed long before the dataDealer is called.
				if(this.config.isSelectionSource || this.config.isSelectionTarget){
					this.updateListOfIDs()
				}

				if(this.config.isSelectionSource){
					if(utils.collectionSize(this.model.blackListedProductIDs) > 0){
						resourceFilters.baseFilters.blackListedProductIDs = this.model.blackListedProductIDs;
					} else {
						resourceFilters.baseFilters.blackListedProductIDs = [];
					}

					if((resourceFilters.filters || {}).selectedOnly){
						resourceFilters.filters.listOfPrimaryKeys = Object.values(this.getSelectedRowIDs(true) || {}) || []
					} else {
						delete resourceFilters.filters.listOfPrimaryKeys
					}
				}

				if(this.config.isSelectionTarget){
					if(utils.collectionSize(this.model.selectedRowIDs) > 0){
						resourceFilters.baseFilters.listOfPrimaryKeys = this.model.selectedRowIDs;
					} else {
						resourceFilters.baseFilters.listOfPrimaryKeys = [];
					}
				}

				resourceFilters.filters = resourceFilters.filters || {};
			}
			return resourceFilters;
		},

		loadResourcesGranted: function(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
			var nrOfFilters = utils.collectionSize((resourceFilters || {}).filters)
			return actionKey !== 'refreshResources' || nrOfFilters > 1 || (nrOfFilters > 0 && resourceFilters.tags_tagConnection === undefined) || this.config.usageMode === 'choose';
		},

		addEntity: function(entity){
			// add entity to dom if possible
			if(this.config.isReady && (this.model.$table || []).length > 0){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }));
			}
		},

		showInsert: function(rowID, rowData, buttonMode){
			return getComponent('mblxController').showInsert('product', {
				componentDefinition: utils.simpleCopy((this.model.controller || {}).resourceData || {})
			});
		},

		showEdit: function(rowID, rowData, buttonMode){
			if (rowID) {
				if(this.config.usage === 'selection'){
					if(this.config.isSelectionSource && this.model.controller){
						this.model.controller.toggleRowSelection(rowID, rowData);
					}
				} else {
					return getComponent('mblxController').showEdit('product', rowData.attributes.routeID, rowData);
				}
			}
		},

		showDuplicate: function(rowID, rowData, buttonMode){
			return getComponent('mblxController').showDuplicate('product', rowData.attributes.routeID, rowData);
		},

		showProtocol: function(rowID, rowData, buttonMode){
			return getComponent('mblxController').showProtocol('product', rowData.attributes.routeID, rowData);
		},

		delete: function(rowID, rowData, buttonMode){
			if(this.config.usage === 'selection'){
				if(this.config.isSelectionTarget){
					if(this.model.isInPicker){
						this.toggleRowSelection(rowID, rowData);
					} else if(this.model.controller){
						this.model.controller.toggleRowSelection(rowID, rowData);
					}
				}
			} else {
				getComponent('mblxController').delete('product', rowData.attributes.routeID, rowData);
			}
		},

		async requestProductAdditionalInformation(rowID, rowData, buttonMode){
			await getComponent('mblxController').requestProductAdditionalInformation('product', rowID, rowData);
		},

		open: function(rowID, rowData, buttonMode){
			var webServiceUrl = ((storage.app || {}).webService || {}).url;
			if(webServiceUrl){
				var routeAttributes = (rowData || {}).attributes || {}
				if(routeAttributes.path){
					window.open(webServiceUrl + routeAttributes.path, '_blank').focus();
				} else {
					console.error('OPEN_ROUTE_PATH_MISSING');
				}
			} else {
				console.error('OPEN_ROUTE_WEB_SERVICE_MISSING');
			}
		},

		openArticleUrl: function(rowID, rowData, buttonMode){
			const articleUrl = ((rowData || {}).attributes || {}).articleUrl
			if(articleUrl){
				window.open(articleUrl, '_blank').focus()
			} else {
				console.error('OPEN_ARTICLE_URL_NOT_POSSIBLE_DUE_TO_MISSING_ARTICLE_URL')
			}
		},

		sourceSelectionChanged: function(){
			if(this.model.isInPicker && this.config.isSelectionSource){
				this.triggerClosest('onTableSelectionChanged', { selectedRowIDs: this.getSelectedRowIDs(true) })
			}
		},

		selectionChanged: function(){
			if(this.model.isInPicker){
				this.triggerClosest('onChildChanged', {
					value: this.getSelectedRowIDs()
				});
			}
		},

		customClickHandler: function(event){
			var bubble = $(event.target).closest('.bubble')
			var tagsColumn = $(event.target).closest('.fieldOf_tags')
			if(bubble.length > 0 && tagsColumn.length > 0){
				var tagKey = bubble.data('tagKey');
				var tagParts = String(tagKey || '').split('_') || [];
				var categoryID = tagParts[0] || 0
				var categoryDataID = tagParts[1] || 0
				if(categoryID && categoryDataID){
					this.triggerClosest('colTagsBubbleSelected', {
						categoryID,
						categoryDataID
					}, 'templates_mblx_products_controller')
					return true;
				}
			}

			return false;
		},

		onAfterLazyLoad: function(errorOccurred){
			if(!errorOccurred){
				this.updateBubbleHighlighting()
			}
		},

		updateBubbleHighlighting: function(){
			var highlightTagBubbles = ((this.model.resourceFilters || {}).filters || {}).tags || [];
			this.$.find('.fieldOf_tags .bubble').removeClass('highlighted');
			if(highlightTagBubbles.length > 0){
				this.$.find(highlightTagBubbles.map(tagKey => `.fieldOf_tags .bubble[data-tag-key="${tagKey}"]`).join(',')).addClass('highlighted');
			}
		},

		export: function(){
			var self = this;
			var nrOfMatchingElements = ((((self.resourceData || {}).nrOfElements || {}).data || {}).attributes || {}).nrOfMatchingElements || 0;
			if(nrOfMatchingElements > self.config.maxNrOfExportElements){
				return self.performDecision(
					'confirm',
					{
						component:  self,
						title:      storage.__('hint.mblx.product.export.limit.title'),
						message:    storage.__('hint.mblx.product.export.limit.message', { max: self.config.maxNrOfExportElements, nrOfMatchingElements })
					}
				).then(function(confirmationContext){
					if(confirmationContext.decision.type === 'yes'){
						self.startExport();
					}
				});
			}

			self.startExport();
		},

		startExport: function(mode, forceExtension){
			var resourceFilters 	= utils.copy(this.getResourceFilters(storage, undefined, 'refreshResources')) || {};
			resourceFilters.offset 	= 0;
			resourceFilters.limit 	= this.config.maxNrOfExportElements;
			var filename = 'mblx_products_' + utils.moment().format('YYYY-MM-DD_hh-mm-ss') + '.xlsx';
			window.open('/LTR/~/exports/mblx/products/products/' + filename + '?body=' + Buffer.from(JSON.stringify({
				resourceFilters: resourceFilters
			})).toString('base64'), '_blank');
		},
	},

	hooks: {
		_attach: function($element, options){
			if(this.model.isInPicker && this.config.isSelectionSource){
				this.triggerClosest('onTableSelectionChanged', { selectedRowIDs: this.getSelectedRowIDs(true) })
			}

			this.updateBubbleHighlighting()
		},

		toggleRowSelection: function($element, options){
			this.toggleRowSelection(options.rowID, options.rowData);
		},
	},

	handlers: [{
		name: 'onSubmitDone',
		componentClass: 'templates_propertiesForms_routePropertiesForm',
		handle: function(callerComponent, nodeData, insertPerformed){
			if(((callerComponent || {}).config || {}).useArticleMode){
				this.refreshData();
			}
		}
	},{
		name: 'onSubmitDone',
		componentClass: 'templates_mblx_products_propertiesForm',
		handle: function(callerComponent, nodeData, insertPerformed){
			this.refreshData(true)
		}
	},{
		name: 'onDeleteMBLXProduct',
		componentClass: 'templates_mblx_controller',
		handle: function(callerComponent, nodeData, insertPerformed){
			this.refreshData();
		}
	},{
		name: 'onUploadComplete',
		componentClass: 'templates_mblx_products_additionalInformation_importerUploader',
		handle: function(callerComponent, success){
			if(success){
				this.refreshData(true)
			}
		}
	},{
		name: 'productAdditionalInformationRequested',
		handle: function(callerComponent, success){
			// according to the actual filters it may be necessary to refresh the actual data (e.g., associatedProductAdditionalInformation)
			this.refreshData(true)
		}
	}]
}
